import Vue from 'vue'
import Router from 'vue-router'
import AboutRouter from '@/router/about'
import CoinsRouter from '@/router/coins'
import GrowRouter from '@/router/grow'
import TaskRouter from '@/router/task'
import FdbackRouter from '@/router/fdback'
import StuFdbackRouter from '@/router/stufdback'
import DetailsRouter from '@/router/details'
import StuReportRouter from '@/router/stureport'
import StuReportRouter1 from '@/router/stureport1'
import StuReportRouterwx from '@/router/stureportwx'
import ProtocolRouter from '@/router/protocol'
import SummerCamp from '@/router/summer-camp'
import summerHomeWork from '@/router/summer-homework'
import ActivityCenterRouter from '@/router/activityCenter'
import StarsRouter from '@/router/stars'
// 中考复习第三轮活动
import ThirdRoundRouter from '@/router/thirdRound'
// 寒假提分营
import WinterCamp from '@/router/winter-camp'
import PaperRecordRouter from '@/router/PaperRecord'


Vue.use(Router)

const tpl = {
  template: '<router-view></router-view>'
}

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/test',
      name: 'Test',
      component: r => require.ensure([], () => r(require('@/views/test')), 'test')
    },
    {
      path: '/login',
      name: 'Login',
      component: r => require.ensure([], () => r(require('@/views/login/login')), 'login')
    },
    {
      path: '/login_correct',
      name: 'login_correct',
      component: r => require.ensure([], () => r(require('@/views/login_correct/login')), 'login_correct')
    },
    {
      path: '/:module?/about',
      alias: '/about',
      name: 'About',
      component: r => require.ensure([], () => r(require('@/views/about/index')), 'about'),
      children: AboutRouter
    },
    {
      path: '/:module(student|teacher)/coins',
      name: 'Coins',
      component: r => require.ensure([], () => r(require('@/views/coins/index')), 'coins'),
      children: CoinsRouter
    },
    {
      path: '/:module(student|teacher)/activitycenter',
      name: 'ActivityCenter',
      component: r => require.ensure([], () => r(require('@/views/coins/index')), 'ActivityCenter'),
      children: ActivityCenterRouter
    },
    {
      path: '/:module(student|teacher)/grow',
      name: 'Grow',
      component: r => require.ensure([], () => r(require('@/views/grow/index')), 'grow'),
      children: GrowRouter
    },
    {
      path: '/detail',
      name: 'subjectDetail',
      component: r => require.ensure([], () => r(require('@/views/subjectDetail/index')), 'subjectDetail'),
      meta: {
        title: '题目详情'
      }
    },
    {
      path: '/task',
      name: 'Task',
      component: tpl,
      children: TaskRouter
    },
    {
      path: '/details',
      name: 'Details',
      component: r => require.ensure([], () => r(require('@/views/details/index')), 'details'),
      children: DetailsRouter
    },
    {
      path: '/paperRecord',
      name: 'PaperRecord',
      component: r => require.ensure([], () => r(require('@/views/paperRecord/index')), 'paperRecord'),
      children: PaperRecordRouter,
      meta: {
        title: '组卷记录'
      }
    },
    {
      path: '/downLoad',
      name: 'DownLoad',
      component: r => require.ensure([], () => r(require('@/views/downLoad/index.vue')), 'DownLoad'),
      meta: {
        title: '下载试卷'
      },
    },
    {
      path: '/fdback',
      name: 'Fdback',
      component: r => require.ensure([], () => r(require('@/views/fdback/index')), 'fdback'),
      meta: {
        title: '帮助与反馈'
      },
      children: FdbackRouter
    },
    {
      path: '/stars',
      name: 'Stars',
      component: r => require.ensure([], () => r(require('@/views/stars/index')), 'stars'),
      meta: {
        title: '星星商城'
      },
      children: StarsRouter,

    },
    {
      path: '/stufdback',
      name: 'StuFdback',
      component: r => require.ensure([], () => r(require('@/views/stufdback/index')), 'stufdback'),
      meta: {
        title: '客服中心'
      },
      children: StuFdbackRouter
    },
    {
      path: '/report',
      name: 'Report',
      component: r => require.ensure([], () => r(require('@/views/report/report')), 'report'),
      meta: {
        title: '学情报告'
      }
    },
    {
      path: '/learnAnalysis',
      name: 'LearnAnalysis',
      component: r => require.ensure([], () => r(require('@/views/learnAnalysis/index')), 'LearnAnalysis'),
      meta: {
        title: '学情报告'
      }
    },
    {
      path: '/errorDetails',
      name: 'ErrorDetails',
      component: r => require.ensure([], () => r(require('@/views/errorDetails/index.vue')), 'ErrorDetails'),
      meta: {
        title: '错题详情'
      }
    },
    //订正错题
    {
      path: '/correctMistakes',
      name: 'CorrectMistakes',
      component: r => require.ensure([], () => r(require('@/views/correctMistakes/index')), 'CorrectMistakes'),
      meta: {
        title: '订正错题'
      }
    },
    {
      path: '/:module(student|teacher)/successful',
      name: 'successful',
      component: r => require.ensure([], () => r(require('@/views/successful/successfulExchange')), 'successful'),
      meta: {
        title: '兑换记录'
      }
    },
    // {
    //     path: '/stureport/:sectionCode',
    //     name: 'chapterReport',
    //     component: r => require.ensure([], () => r(require('@/views/studyReport/chapterReport')), 'chapterReport'),
    //     meta: {
    //         title: '学情报告'
    //     }
    // },

    //学生个人作业报告
    {
      path: '/homeworkPage',
      name: 'HomeworkPage',
      component: r => require.ensure([], () => r(require('@/views/homeworkPage/index')), 'HomeworkPage'),
      meta: {
        title: '学生作业'
      },
    },
    {
      path: '/studentPageDetails',
      name: 'StudentPageDetails',
      component: r => require.ensure([], () => r(require('@/views/studentPageDetails/index')), 'StudentPageDetails'),
      // meta: {
      //     title: '学生作业详情'
      // },
    },
    {
      path: '/blank',
      name: 'Blank',
      component: r => require.ensure([], () => r(require('@/views/studentPageDetails/blank')), 'Blank'),
      meta: {
        title: '学生作业详情'
      },
    },
    {
      path: '/studentPageDetailsTwo',
      name: 'StudentPageDetailsTwo',
      component: r => require.ensure([], () => r(require('@/views/studentPageDetailsTwo/index')), 'StudentPageDetailsTwo'),
      meta: {
        title: '学生作业详情'
      },
    },
    {
      path: '/homeworkItemAnalysis',
      name: 'HomeworkItemAnalysis',
      component: r => require.ensure([], () => r(require('@/views/homeworkItemAnalysis/index')), 'HomeworkItemAnalysis'),
      meta: {
        title: '题目分析'
      },
    },
    {
      path: '/videosharing',
      name: 'videoSharing',
      component: r => require.ensure([], () => r(require('@/views/videoSharing/VideoSharing')), 'videoSharing'),
      meta: {
        title: '云讲题-好老师2分钟让你学会一道题'
      },
    },
    {
      path: '/teachingservice',
      name: 'teachingService',
      component: r => require.ensure([], () => r(require('@/views/teachingService/teachingService')), 'teachingService'),
      meta: {
        title: '教学服务'
      },
    },
    {
      path: '/parentalguidance',
      name: 'parentalGuidance',
      component: r => require.ensure([], () => r(require('@/views/parentalGuidance/parentalGuidance')), 'parentalGuidance'),
      meta: {
        title: '家长辅导'
      },
    },
    {
      path: '/:module(student|teacher)/exchangerecords',
      name: 'exchangeRecords',
      component: r => require.ensure([], () => r(require('@/views/exchangeRecords/exchangeRecords')), 'exchangeRecords'),
      meta: {
        title: '兑换记录'
      },
    },
    {
      path: '/:module(student|teacher)/commodityDetails',
      name: 'commodityDetails',
      component: r => require.ensure([], () => r(require('@/views/commodityDetails/commodityDetails')), 'commodityDetails'),
      meta: {
        title: '详情'
      },
    },
    {
      path: '/:module(student|teacher)/exchangeOrder',
      name: 'exchangeOrder',
      component: r => require.ensure([], () => r(require('@/views/exchangeOrder/exchangeOrder')), 'exchangeOrder'),
      meta: {
        title: '提交兑换订单'
      },
    },
    {
      path: '/:module(student|teacher)/numberChange',
      name: 'numberChange',
      component: r => require.ensure([], () => r(require('@/views/numberChange/numberChange')), 'numberChange'),
      meta: {
        title: '更换手机号'
      },
    },
    {
      path: '/:module(student|teacher)/bindMobile',
      name: 'bindMobile',
      component: r => require.ensure([], () => r(require('@/views/numberChange/bindMobile')), 'bindMobile'),
      meta: {
        title: '绑定手机号'
      },
    },

    {
      path: '/stureport',
      name: 'stureport',
      component: r => require.ensure([], () => r(require('@/views/studyReport/index')), 'studyReport'),
      meta: {
        title: '学情报告'
      },
      children: StuReportRouter
    },
    {
      path: '/stureport1',
      name: 'stureport',
      component: r => require.ensure([], () => r(require('@/views/studyReport/index')), 'studyReport'),
      meta: {
        title: '学情报告'
      },
      children: StuReportRouter1
    },
    {
      path: '/stureportwx',
      name: 'stureportwx',
      component: r => require.ensure([], () => r(require('@/views/studyReportwx/index')), 'studyReportwx'),
      meta: {
        title: '学情报告'
      },
      children: StuReportRouterwx
    },
    {
      path: '/reportStu/:userId/:startDate?/:endDate?',
      name: 'ReportStu',
      component: r => require.ensure([], () => r(require('@/views/report/reportStu')), 'reportStu'),
      meta: {
        title: '周度成绩报告'
      }
    },
    {
      path: '/reportStu1/:userId/:startDate?/:endDate?',
      name: 'ReportStu1',
      component: r => require.ensure([], () => r(require('@/views/report/reportStu1')), 'reportStu1'),
      meta: {
        title: '周度成绩报告'
      }
    },
    {
      path: '/reportStuwx/:userId/:startDate?/:endDate?',
      name: 'ReportStuwx',
      component: r => require.ensure([], () => r(require('@/views/report/reportStuwx')), 'reportStuwx'),
      meta: {
        title: '周度成绩报告'
      }
    },
    {
      path: '/menulist',
      name: 'menulist',
      component: r => require.ensure([], () => r(require('@/views/pay/menulist')), 'menulist'),
      meta: {
        title: ''
      }
    },
    {
      path: '/pay-fast-one',
      name: 'pay-fast-one',
      component: r => require.ensure([], () => r(require('@/views/pay/payFastOne')), 'pay-fast-one'),
      meta: {
        title: '付费选择'
      }
    },
    {
      path: '/paycomplete',
      name: 'paycomplete',
      component: r => require.ensure([], () => r(require('@/views/pay/paycomplete')), 'paycomplete'),
      meta: {
        title: '支付完成'
      }
    },
    {
      path: '/protocol',
      component: tpl,
      children: ProtocolRouter
    },
    {
      path: '/payguide',
      component: r => require.ensure([], () => r(require('@/views/report/payguide')), 'pay'),
      meta: {
        title: '如何开通悠数学会员'
      }
    },
    {
      path: '/statistic',
      component: r => require.ensure([], () => r(require('@/views/errorbook/statistic')), 'statistic'),
      meta: {
        title: '错题统计'
      }
    },
    {
      path: '/statistic/:sectionCode',
      component: r => require.ensure([], () => r(require('@/views/errorbook/errordetails')), 'errordetails'),
      meta: {
        title: '易错知识点'
      }
    },
    {
      path: '/reviewact',
      component: r => require.ensure([], () => r(require('@/views/reviewAct/reviewAct')), 'review'),
      meta: {
        title: '备战2018中考'
      }
    },
    // 中考第二轮开始
    {
      path: '/ExamStudent',
      component: r => require.ensure([], () => r(require('@/examination/student/student')), 'stu'),
      meta: {
        title: '备战2018中考'
      }
    },
    {
      path: '/info',
      component: r => require.ensure([], () => r(require('@/examination/student/info')), 'info'),
      meta: {
        title: '中考一模测评'
      }
    },
    {
      path: '/Examrank',
      component: r => require.ensure([], () => r(require('@/examination/student/rank')), 'rank'),
      meta: {
        title: '评测排名'
      }
    },
    {
      path: '/ExamTeacher',
      component: r => require.ensure([], () => r(require('@/examination/teacher/teacher')), 'tea'),
      meta: {
        title: '备战2018中考'
      }
    },
    {
      path: '/payonly',
      component: r => require.ensure([], () => r(require('@/examination/payOnly')), 'payonly'),
      meta: {
        title: '专题购买'
      }
    },
    // 中考第二轮结束
    // 中考第三轮开始
    {
      path: '/ExamRecommend',
      component: r => require.ensure([], () => r(require('@/examination/student/student')), 'stu'),
      meta: {
        title: '备战2018中考'
      }
    },
    {
      path: '/thirdRound',
      component: r => require.ensure([], () => r(require('@/examination/thirdRound/index')), 'thirdRound'),
      meta: {
        title: '备战2018中考'
      },
      children: ThirdRoundRouter
    },
    // 中考第三轮结束
    // 暑期 训练/提分 营
    {
      path: '/summer',
      redirect: '/summer/home',
      component: {
        template: `<router-view class="main"></router-view>`
      },
      children: SummerCamp
    },
    // 助力活动（送会员）
    {
      path: '/tea-itr',
      component: r => require.ensure([], () => r(require('@/views/share-act/teacher/itr')), 'teaItr'),
      meta: {
        title: '新用户大礼包'
      }
    },
    {
      path: '/stu-itr',
      component: r => require.ensure([], () => r(require('@/views/share-act/student/itr')), 'stuItr'),
      meta: {
        title: '新用户大礼包'
      }
    },
    // 寒假提分营
    {
      path: '/winter',
      component: r => require.ensure([], () => r(require('@/views/winter-camp')), 'winterCamp'),
      meta: {
        title: '寒假提分营'
      },
      children: WinterCamp,
    },
    {
      path: '/summer-homework',
      component: r => require.ensure([], () => r(require('@/views/summer-homework')), 'summerHomeWork'),
      meta: {
        title: '暑假作业'
      },
      children: summerHomeWork,
    },
    // 跳转中间页面
    {
      path: '/redirect',
      component: r => require.ensure([], () => r(require('@/views/redirect')), 'redirect'),
      meta: {
        title: '跳转中'
      },
    },
    {
      path: '/up-notice',
      component: r => require.ensure([], () => r(require('@/views/up-notice')), 'upNotice'),
      meta: {
        title: '升级通知'
      }
    },

    {
      path: '/correctList',
      component: r => require.ensure([], () => r(require('@/views/correct_voucher/correctList')), 'correctList'),
      name: 'correctList',
      meta: {
        title: '获取教师批改券'
      }
    },
    {
      path: '/correctFaq',
      component: r => require.ensure([], () => r(require('@/views/correct_voucher/correctFaq')), 'correctFaq'),
      name: 'correctFaq',
      meta: {
        title: '批改券介绍'
      }
    },
    // // 快速入门
    {
      path: '/faq/quickStart',
      name: 'quickStart',
      component: r => require.ensure([], () => r(require('@/views/faq/quickStart')), 'quickStart'),
      meta: {
        title: '快速入门'
      }
    },
    {
      path: '/faq/subjob',
      name: 'subjob',
      component: r => require.ensure([], () => r(require('@/views/faq/subjob')), 'subjob'),
      meta: {
        title: '提交作业'
      }
    },
    {
      path: 'seDetail',
      name: 'seDetail',
      component: r => require.ensure([], () => r(require('@/views/details/seDetail')), 'detail'),
      meta: {
        title: ''
      }
    },
    {
      path: '/sendMembers',
      name: 'sendMembers',
      component: r => require.ensure([], () => r(require('@/views/membersActive/sendMembers')), 'sendMembers'),
      meta: {
        title: '新用户大礼包'
      }
    },
    {
      path: '/coachBooksFaq',
      name: 'coachBooksFaq',
      component: r => require.ensure([], () => r(require('@/views/coachBooks/coachBooksFaq')), 'coachBooksFaq'),
      meta: {
        title: '智能教辅书系列手册'
      }
    },
    {
      path: '/coachBooksList',
      name: 'coachBooksList',
      component: r => require.ensure([], () => r(require('@/views/coachBooks/coachBooksList')), 'coachBooksList'),
      meta: {
        title: '智能教辅书系列手册'
      }
    },
    // 培优计划
    // {
    //     path: '/training-plan',
    //     component: r => require.ensure([], () => r(require('@/views/training-plan')), 'trainingPlan'),
    //     meta: {
    //         title: '培优计划'
    //     }
    // }

    // 教室端的查看
    {
      path: '/check',
      name: 'Check',
      component: r => require.ensure([], () => r(require('@/views/check/index')), 'Check'),
      meta: {
        title: '学情分析'
      }
    },
    //4.2.1
    {
      path: '/learningSituationTest',
      name: 'LearningSituationTest',
      component: r => require.ensure([], () => r(require('@/views/learningSituationTest')), 'LearningSituationTest'),
      meta: {
        title: '学情报告'
      }
    },
    {
      path: '/learningnalysis',
      name: 'learningnalysis',
      component: r => require.ensure([], () => r(require('@/views/learningnalysis/learningnalysis')), 'learningnalysis'),
      meta: {
        title: '学情报告'
      }
    },
    {
      path: '/mistakeDetails',
      name: 'MistakeDetails',
      component: r => require.ensure([], () => r(require('@/views/mistakeDetails')), 'MistakeDetails'),
      meta: {
        title: '题目分析'
      }
    },
    {
      path: '/xushengzuoye',
      name: 'Xushengzuoye',
      component: r => require.ensure([], () => r(require('@/views/xushengzuoye')), 'Xushengzuoye'),
      meta: {
        title: '学生作业'
      }
    },
    //这是悠数学小程序(教师端和学生端)
    {
      path: '/testDetails',
      name: 'TestDetails',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/testDetails')), 'TestDetails'),
      meta: {
        title: '学生作业详情'
      }
    },
    {
      path: '/wrongQues',
      name: 'wrongQues',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/wrongQues')), 'wrongQues'),
      meta: {
        title: '错题本'
      }
    },
    {
      path: '/wrongDownload',
      name: 'wrongDownload',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/wrongQues/wrongDown.vue')), 'wrongDown'),
      meta: {
        title: '错题本下载'
      }
    },
    {
      path: '/wrongQuestionInfo',
      name: 'wrongQuestionInfo',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/wrongQues/questionInfo.vue')), 'wrongQuestionInfo'),
      meta: {
        title: '错题详情'
      }
    }, {
      path: '/testDetailsTeacher',
      name: 'TestDetailsTeacher',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/testDetailsTeacher')), 'TestDetailsTeacher'),
      meta: {
        title: '学生作业'
      }
    },
    {
      path: '/correctWrong',
      name: 'CorrectWrong',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/correctWrong')), 'CorrectWrong'),
      meta: {
        title: '错题订正'
      }
    },
    {
      path: '/correctWrongApp',
      name: 'correctWrongApp',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/correctWrongApp')), 'correctWrongApp'),
      meta: {
        title: '错题订正'
      }
    },
    {
      path: '/correctWrongAppOld',
      name: 'correctWrongAppOld',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/correctWrongAppOld')), 'correctWrongAppOld'),
      meta: {
        title: '错题订正'
      }
    },
    {
      path: '/questionOut',
      name: 'questionOut',
      component: r => require.ensure([], () => r(require('@/views/yoomathTwo/wrongQues/questionOut.vue')), 'questionOut'),
      meta: {
        title: '错题导出'
      }
    },
    {
      path: '/manualCropperImg',
      name: 'manualCropperImg',
      component: r => require.ensure([], () => r(require('@/views/manualCropperImg')), 'manualCropperImg'),
      meta: {
        title: '裁切编辑' // 
      }
    },
    {
      path: '/manualQuestionCropper',
      name: 'manualQuestionCropper',
      component: r => require.ensure([], () => r(require('@/views/manualQuestionCropper')), 'manualQuestionCropper'),
      meta: {
        title: '调整切题区域' // 
      }
    },
    {
      path: '/correct',
      name: 'correct',
      component: r => require.ensure([], () => r(require('@/views/correct/correct.vue')), 'correct'),
      // meta: {
      //   title: '小悠快批2'
      // }
    }
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js